import React from 'react';
import './ScrollToTop.css';

const ScrollToTop = ({ show, onClick }) => {
  return (
    <button 
      className={`scroll-to-top ${show ? 'show' : ''}`}
      onClick={onClick}
      aria-label="Scroll to top"
    >
      <span>↑</span>
    </button>
  );
};

export default ScrollToTop;

